<mat-form-field>
  <mat-select  name="value" [required]="required" [(ngModel)]="value" [formControl]="select"
    [disableOptionCentering]="true" [disabled]="disabled" [multiple]="multiple" [tabIndex]="tabIndex">
    <mat-option>
      <ngx-mat-select-search [formControl]="filter" [placeholderLabel]="'Buscar'"
        [noEntriesFoundLabel]="'No hay registros que coincidan'"></ngx-mat-select-search>
    </mat-option>
    <mat-option *ngIf="emptyOption && !multiple && value !== undefined">--</mat-option>
    <mat-option *ngFor="let item of itemsFiltered | async" [(value)]="item[valueColumn]">
      {{ getDescription(item) }}
    </mat-option>
  </mat-select>
  <mat-label>
    <ng-container *ngIf="loading; else notSpinnerBlock">
      <span style="float: right;"><mat-spinner class="spinner" diameter="20"></mat-spinner></span>
      {{placeHolder}}
    </ng-container>
    <ng-template #notSpinnerBlock>
      {{placeHolder}}
    </ng-template>
  </mat-label>

  <button *ngIf="value && (!disabled)  && emptyOption" matSuffix mat-icon-button type="button" aria-label="Clear"
    (click)="clearSelectedValue($event)">
    <mat-icon>close</mat-icon>
  </button>
</mat-form-field>
